import { Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { SetStateAction, useEffect, useState } from "react";
import {
  formatDate,
  getCorrectLanguage,
} from "../../../shared/functions/Functions";
import { Pagination } from "../../../shared/paginations/Paginations";
import Select, { SingleValue } from "react-select";
import { themeSelect } from "../../../shared/components/Select2";
import { ConfirmDelete } from "../../../shared/components/ConfirmDelete";
import { EmptyState } from "../../../shared/components/EmptyState";
import { IExport } from "../../exports/dto/IExports";
import { ErrorToast } from "../../../shared/toasters/toasters";
// import { ContentService } from "../service";
// import { IContent } from "../dto/IContent";
import { LoadingAnimation } from "../../../shared/components/Loading";
import { ContentService } from "../../content/service";
import { IContent } from "../../content/dto/IContent";
import { ClientDashboardService } from "../service";

interface IExportListProps {
  editHandler: (id: number) => void;
  setContentId: any;
  setCreateField: any;
  accessRights: string[];
  dataHistoryList: any;
  setTriggerUpdate: React.Dispatch<SetStateAction<boolean>>;
  totalPages: number;
  page: number;
  handlePages: (page: number) => void;
  changeClientHandler: (value: any) => void;
  clientList: IExport[];
  changeFilterClientHandler: (
    selectedSingle: SingleValue<IExport | null>,
    inputKey: string
  ) => void;
  changeFilterHandler: (e: any) => void;
  userClientList: Array<any>[];
  userClientDashboardCanEdit: boolean;
  pagination: any;
}

export const DataHistoryList = ({
  pagination,
  editHandler,
  dataHistoryList,
  clientList,
  totalPages,
  page,
  handlePages,
  setCreateField,
  setContentId,
  changeFilterClientHandler,
  //   changeClientHandler,
  setTriggerUpdate,
  //   changeFilterHandler,
  accessRights,
  userClientList,
  userClientDashboardCanEdit,
}: IExportListProps) => {
  const [windowWidth, setWindowWidth] = useState(getWindowDimensions());
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [selectedContent, setselectedContent] = useState<IContent>();
  const handleDownload = (files: any[]) => {
    files.forEach((file: any) => {
      const xhr = new XMLHttpRequest();
      const fileName = file?.file?.nameOriginal;
      xhr.open("GET", file?.path, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = new Blob([xhr.response], { type: "application/*" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName ?? "";
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }, 0);
        }
      };
      xhr.send();
    });
  };
  const deleteHandler = () => {
    selectedContent?.id &&
      ClientDashboardService.deleteDataHistoryById(selectedContent?.id)
        .then((response) => {
          if (response === "") {
            setTriggerUpdate((prev) => !prev);
          }
        })
        .catch((error) => ErrorToast(error));
  };
  useEffect(() => {
    function handleResize() {
      setWindowWidth(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  function getWindowDimensions() {
    const { innerWidth: width } = window;
    return {
      width,
    };
  }

  return (
    <div className="card">
      <div className="card-header pb-0">
        <div className="d-flex justify-content-between">
          <h4 className="card-title mg-b-0">
            {`${t("client_dashboard.list_of_data_history")}`}
          </h4>
        </div>
      </div>
      <div className="card-body">
        {(dataHistoryList?.length > 0 || pagination?.client > 0) && (
          <div className="d-flex justify-content-start align-items-center mb-1">
            <div className="col-md-3 my-2">
              <input
                type="text"
                name="title"
                required
                placeholder={t("products.term")}
                //   onChange={changeFilterHandler}
                className="form-control"
              />
            </div>
            {userClientList?.length > 1 && (
              <Select
                theme={themeSelect}
                isClearable
                placeholder={t("export_client.client")}
                className={`${
                  windowWidth?.width > 767 ? `w-25` : `w-50`
                } ms-1 react-select-field`}
                onChange={(e) => {
                  changeFilterClientHandler(
                    e as SingleValue<IExport | null>,
                    "client"
                  );
                }}
                options={userClientList as any}
              />
            )}
          </div>
        )}

        {dataHistoryList == undefined ? (
          <LoadingAnimation />
        ) : dataHistoryList?.length === 0 ? (
          <EmptyState />
        ) : (
          <div className="table-responsive">
            <Table className="align-middle table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th scope="col">{`${t("global.id")}`}</th>
                  <th scope="col">{`${t("global.name")}`}</th>
                  <th scope="col">{`${t("export_client.client")}`}</th>
                  <th scope="col">{`${t("products.createdAt")}`}</th>
                  {userClientDashboardCanEdit ? (
                    <th scope="col">{`${t("global.actions")}`}</th>
                  ) : (
                    <th scope="col">{`${t("global.action")}`}</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {dataHistoryList?.map((content: any) => {
                  return (
                    <tr key={content?.id}>
                      <td>
                        <Link to="#" className="fw-medium">
                          #{content?.id}
                        </Link>
                      </td>
                      <td>{content?.name ?? "-"}</td>
                      <td>{content?.client?.name ?? "-"}</td>
                      <td>{formatDate(content?.createdAt)}</td>

                      <td>
                        <div className="d-flex align-items-center justify-content-center">
                          {userClientDashboardCanEdit && (
                            <>
                              <button
                                className="btn btn-sm btn-warning d-flex align-items-center me-2"
                                onClick={() => editHandler(Number(content?.id))}
                              >
                                <i className="ri-edit-2-fill me-1" />
                                {`${t("global.edit")}`}
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center me-2"
                                onClick={() => {
                                  handleShow();
                                  setselectedContent(content);
                                }}
                              >
                                <i className="ri-delete-bin-fill me-1" />
                                {`${t("global.delete")}`}
                              </button>
                            </>
                          )}
                          <button
                            onClick={() => handleDownload(content?.documents)}
                            className="btn btn-sm  btn-secondary d-flex align-items-center me-2"
                            disabled={content?.documents?.length === 0 && true}
                          >
                            <i className="ri-file-download-fill me-1" />
                            {t("global.document")}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}

        <div className="d-flex justify-content-end ">
          {totalPages <= 1 ? (
            ""
          ) : (
            <Pagination
              page={page}
              totalPages={totalPages}
              handlePagination={handlePages}
            />
          )}
        </div>
        <ConfirmDelete
          show={show}
          setShow={setShow}
          itemName={selectedContent?.name}
          deleteHandler={deleteHandler}
          product={selectedContent}
          selectedProduct={selectedContent}
        />
      </div>
    </div>
  );
};
